import CurriculumMap from './CurriculumMap';

export default CurriculumMap;
